export default "__VITE_ASSET__Dv029Baw__"